import compact from 'lodash/compact'

import { Employees } from 'modules/employees/store/collections/employees'
import type Schedule from 'modules/work_schedules/store/models/Schedule'

export const workScheduleEmployees = (schedule: Schedule, employees: Employees) => {
  return compact(schedule.employeeIds.map((id: number) => employees.get(id)))
}
